/**
 * Custom zoom-slider based on https://github.com/skozer/react-instagram-zoom-slider
 */

import classNames from 'classnames';
import { ReactNodeLike } from 'prop-types';
import React from 'react';

import ZoomSlider from '../ReactInstagramZoomSlider';

type Props = {
  slides: any[];
  maxScale?: number;
  minScale?: number;
  slideOverlay?: ReactNodeLike;
  className?: string;
};

const Carousel = (props: Props) => {
  const { slides, maxScale, minScale, slideOverlay, className } = props;

  return (
    <div className={classNames('carousel-container', className)}>
      <div className="carousel-wrapper">
        <ZoomSlider
          slides={slides}
          maxScale={maxScale}
          minScale={minScale}
          slideOverlay={slideOverlay}
          dotColor="rgba(0, 0, 0, 0.2)"
          activeDotColor="white"
          cut={16}
        />
      </div>
    </div>
  );
};

export default Carousel;
